export const ROLES = {
    AGENT: 1, 
	"SALES MANAGER":2,
	"AREA MANAGER":3,
    "CAMPAIGN LEAD":4
}
